import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseContentService } from "./base-content-service";
import { UpdatePasswordSitecoreContent } from "./def/update-password-content";
import { of } from 'rxjs/internal/observable/of';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from '@tmhcc-ng-lib/global-services';

@Injectable({
    providedIn: 'root'
})
export class UpdatePasswordContentService extends BaseContentService<
UpdatePasswordSitecoreContent
>
{
    constructor(
        protected http: HttpClient,
        protected configService: AppConfigService
    ) {
        super(http, configService, UpdatePasswordContentService.staticUpdatePassword);
    }

    get data$(): Observable<UpdatePasswordSitecoreContent> {
        if (!this.loaded) {
            return this.getUpdatePasswordData();
        }
        return of(this.data);
    }


    getUpdatePasswordData(): Observable<UpdatePasswordSitecoreContent> {
        const url = `${this.serviceBaseUrl}updatepassword`;
        return this.get<UpdatePasswordSitecoreContent>(url).pipe(
            map(data => {
                this.data = this.updatePasswordMapper(data);
                this.loaded = true;
                return this.data;
            }),
            catchError(this.handleError)
        );
    }

    private updatePasswordMapper(data: UpdatePasswordSitecoreContent): UpdatePasswordSitecoreContent {
        if (!data) return;
        return data;
    }

    private static staticUpdatePassword: UpdatePasswordSitecoreContent = {
        pageName: '',
        forms: [
            {
                formName: '',
                isAdvanceSearch: false,
                fields: [
                    {
                        colClass: '',
                        isDisabled: true,
                        isVisible: true,
                        isAdvanceSearch: false,
                        orderId: null,
                        fieldInfo: {
                            fieldName: '',
                            label: '',
                            fieldType: '',
                            fieldID: '',
                            fieldValue: '',
                            showLabel: true,
                            labelOnly: false,
                            required: false,
                            fieldLength: null,
                            minChar: null,
                            maxChar: null,
                            decimal: null,
                            pattern: '',
                            allowDash: false,
                            validations: []
                        },
                        config: null
                    },
                    {
                        colClass: '',
                        isDisabled: false,
                        isVisible: true,
                        isAdvanceSearch: false,
                        orderId: null,
                        fieldInfo: {
                            fieldName: '',
                            label: '',
                            fieldType: '',
                            fieldID: '',
                            fieldValue: '',
                            showLabel: true,
                            labelOnly: false,
                            required: false,
                            fieldLength: null,
                            minChar: null,
                            maxChar: null,
                            decimal: null,
                            pattern: '',
                            allowDash: false,
                            validations: [
                                {
                                    key: '',
                                    value: ''
                                },
                                {
                                    key: '',
                                    value: ''
                                },
                                {
                                    key: '',
                                    value: ''
                                },
                                {
                                    key: '',
                                    value: ''
                                },
                                {
                                    key: '',
                                    value: ''
                                }
                            ]
                        },
                        config: null
                    },
                    {
                        colClass: '',
                        isDisabled: false,
                        isVisible: true,
                        isAdvanceSearch: false,
                        orderId: null,
                        fieldInfo: {
                            fieldName: '',
                            label: '',
                            fieldType: '',
                            fieldID: '',
                            fieldValue: '',
                            showLabel: true,
                            labelOnly: false,
                            required: false,
                            fieldLength: null,
                            minChar: null,
                            maxChar: null,
                            decimal: null,
                            pattern: '',
                            allowDash: false,
                            validations: [
                                {
                                    key: '',
                                    value: ''
                                },
                                {
                                    key: '',
                                    value: ''
                                }
                            ]
                        },
                        config: null
                    }
                ],
                uniqueItemId: ''
            }
        ],
        data: [
            {
                heading: '',
                title: '',
                description: '',
                text: '',
                image: null,
                displayItems: [
                    {
                        keyText: '',
                        description: '',
                        apiMappingKey: '',
                        navigation: null,
                        orderId: null,
                        image: null,
                        icon: '',
                        options: ''
                    },
                    {
                        keyText: '',
                        description: '',
                        apiMappingKey: '',
                        navigation: null,
                        orderId: null,
                        image: null,
                        icon: '',
                        options: ''
                    },
                    {
                        keyText: '',
                        description: '',
                        apiMappingKey: '',
                        navigation: null,
                        orderId: null,
                        image: null,
                        icon: '',
                        options: ''
                    }
                ],
                uniqueItemId: ''
            }
        ],
        buttons: [
            {
                keyText: '',
                uniqueItemId: ''
            },
            {
                keyText: '',
                uniqueItemId: ''
            }
        ]
    }
}
